enum SYSTEM_ASIDES {
  ANIMALS_IN_CARE_INFO = 'ANIMALS_IN_CARE_INFO',
  APPLICATION_DETAILS = 'APPLICATION_DETAILS',
  CART_ASIDE = 'CART_ASIDE',
  FA_DETAILS_ASIDE = 'FA_DETAILS_ASIDE',
  FS_BITE_REPORT_ASIDE = 'FS_BITE_REPORT_ASIDE',
  FS_CITATIONS_ASIDE = 'FS_CITATIONS_ASIDE',
  RECEIPTS_ASIDE = 'RECEIPTS_ASIDE',
}

export { SYSTEM_ASIDES };
